"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _PassthruRtePlugins = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/config/PassthruRtePlugins"));

var LocalInteractionTransform = _interopRequireWildcard(require("customer-data-communicator/schema/communicator/interaction/local/LocalInteractionTransform"));

var LocalEmailTransform = _interopRequireWildcard(require("customer-data-communicator/schema/interactions/email/LocalEmailTransform"));

var _default = (0, _InteractionDescriptorRecord.default)({
  type: _InteractionTypes.EMAIL,
  icon: 'email',
  engagementType: _EngagementTypes.default.EMAIL,
  passthruRtePlugins: new _PassthruRtePlugins.default(),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform, LocalEmailTransform]),
  applicable: (0, _immutable.Seq)()
});

exports.default = _default;
module.exports = exports.default;